var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIsotipo2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_2",
    "data-name": "Capa 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 37.85 78.46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #f8bd00;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m19.73,78.46l18.12-18.12v-11.51l-3.18-3.25,3.18-4.98v-21.13l-18.12,18.12v40.87Zm5.92-40.4l6.9-6.99v8.06c0,2.6-1.03,5.1-2.85,6.96-1.48,1.5-4.05.45-4.05-1.66v-6.36Zm0,20.63c0-2.64,1.04-5.18,2.9-7.06,1.47-1.49,4.01-.45,4.01,1.64v6.92l-6.9,6.99v-8.5Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 6.33,
    y: 5.38,
    width: 25.95,
    height: 25.95,
    transform: "translate(-7.32 19.03) rotate(-45)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: ".81 23.92 0 23.92 0 23.92 0 60.68 16.52 77.2 16.52 77.2 16.52 76.06 .81 60.35 .81 23.92"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIsotipo2);
export default __webpack_public_path__ + "static/media/isotipo2.d85aa4acbbbbb7c55a000b0bb81a619c.svg";
export { ForwardRef as ReactComponent };